import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const SeoDetails = forwardRef(function SeoDetails(props, ref) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [errors, setErrors] = useState({});
  const [imageKey, setImageKey] = useState("");
  const thumbnailRef = useRef();

  useEffect(() => {
    resetData();
    if (props.data) {
      setTitle(props.data.title);
      setDescription(props.data.description);
      setKeywords(props.data.keywords);
      setImageKey(props.data.imageKey);
      thumbnailRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      thumbnailRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setTitle("");
    setDescription("");
    setKeywords("");
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  }

  const validate = () => {
    const errors = {};

    if (!title || (title && title.trim() == "")) {
      errors.title = "Site title is required";
    }

    if (!description || (description && description.trim() == "")) {
      errors.description = "Site description is required";
    }

    if (!thumbnailRef?.current?.getImageFile() && imageKey.trim() == "") {
      errors.imageKey = "Site image is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return {
      title: title,
      description: description,
      keywords: keywords,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: thumbnailRef?.current?.getImageFile() ?? null,
      imageKey: imageKey
    };
  }

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <>
      <div className="content" style={{ display: "block", visibility: "visible" }}>
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">SEO Details</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
            <div className="col-sm-6">
              <div className="col-sm-12">
                <label className="form-label required" htmlFor="siteTitle">
                  Site Title
                </label>
                <input
                  type="text"
                  id="siteTitle"
                  name="siteTitle"
                  className={`form-control ${errors.title ? "is-invalid" : ""}`}
                  placeholder="Enter site title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {errors.title && (
                  <div className="invalid-feedback">
                    {errors.title}
                  </div>
                )}
              </div>
              <div className="col-sm-12 mt-3">
                <label className="form-label required" htmlFor="description">
                  Site Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  style={{ height: "150px", resize: "none" }}
                  className={`form-control ${errors.description ? "is-invalid" : ""}`}
                  placeholder="Enter description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {errors.description && (
                  <div className="invalid-feedback">
                    {errors.description}
                  </div>
                )}
              </div>
              <div className="col-sm-12 mt-3" >
                <label className="form-label" htmlFor="keywords">
                  Keywords
                </label>
                <textarea
                  id="keywords"
                  name="keywords"
                  style={{ height: "100px", resize: "none" }}
                  className={`form-control ${errors.keywords ? "is-invalid" : ""}`}
                  placeholder="Enter keywords"
                  value={keywords}
                  onChange={(e) => setKeywords(e.target.value)}
                />
                {errors.keywords && (
                  <div className="invalid-feedback">
                    {errors.keywords}
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="siteImage">
                Site Thumbnail <small className="text-gray">(Max Allowable File Size: 1MB,Dimensions: 750px x 750px)</small>
              </label>
              <ImageBrowse elementId="siteImage" ref={thumbnailRef} imageType="profile"
                imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
              {errors.imageKey && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.imageKey}
                </div>
              )}
            </div>
          </div>
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </form>
      </div>
    </>
  );
});

export default SeoDetails;